'use client';
import React, { useState } from 'react';

const faqs = [
  {
    q: 'Como funciona o teste gratuito?',
    a: 'Você tem 14 dias completos para testar todas as funcionalidades do plano escolhido, sem precisar inserir cartão de crédito. Ao final do período, escolha se quer continuar ou não.',
  },
  {
    q: 'Preciso instalar alguma coisa?',
    a: 'Não. O NegócioFácil é 100% online. Basta acessar pelo navegador — computador, tablet ou celular — sem instalação, sem atualizações manuais.',
  },
  {
    q: 'Funciona no celular?',
    a: 'Sim! A plataforma é totalmente responsiva e funciona perfeitamente em smartphones. Você pode gerenciar seu negócio de qualquer lugar.',
  },
  {
    q: 'Posso cancelar quando quiser?',
    a: 'Sim. Não há fidelidade nem multa por cancelamento. Você cancela quando quiser diretamente nas configurações da sua conta.',
  },
  {
    q: 'Meus dados ficam seguros?',
    a: 'Sim. Utilizamos criptografia de nível empresarial, backup automático diário na nuvem e infraestrutura segura. Seus dados nunca são compartilhados com terceiros.',
  },
  {
    q: 'Como funciona o suporte?',
    a: 'Oferecemos suporte via chat, WhatsApp e e-mail. No plano Pro, o suporte é prioritário 24 horas por dia, 7 dias por semana.',
  },
  {
    q: 'Como funciona a emissão de nota fiscal?',
    a: 'A emissão de NF-e, NFC-e e NFS-e é um módulo adicional cobrado separadamente conforme o volume de notas emitidas. Entre em contato para mais detalhes.',
  },
  {
    q: 'Como funciona o cardápio digital?',
    a: 'Você cria seu cardápio dentro do sistema, gera um QR Code e disponibiliza nas mesas. Os clientes fazem o pedido pelo celular e ele vai direto para a cozinha.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-24 px-4 sm:px-6 relative">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/20 bg-primary/5 text-xs font-bold uppercase tracking-widest text-primary mb-6">
            <span className="w-2 h-2 rounded-full bg-primary" />
            FAQ
          </span>
          <h2 className="text-section-title font-black text-foreground mb-4">
            Perguntas{' '}
            <span className="gradient-text">frequentes</span>
          </h2>
        </div>

        <div className="space-y-0">
          {faqs?.map((faq, i) => (
            <div key={i} className="faq-item">
              <button
                className="w-full flex items-center justify-between py-5 text-left group"
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                aria-expanded={openIdx === i}
              >
                <span className={`text-base font-semibold transition-colors ${openIdx === i ? 'text-primary' : 'text-foreground group-hover:text-primary'}`}>
                  {faq?.q}
                </span>
                <span className={`ml-4 w-8 h-8 rounded-full border border-border flex items-center justify-center flex-shrink-0 transition-all duration-300 ${openIdx === i ? 'bg-primary/10 border-primary/30 rotate-45' : ''}`}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={openIdx === i ? 'text-primary' : 'text-muted-foreground'}>
                    <path d="M12 5v14"/><path d="M5 12h14"/>
                  </svg>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIdx === i ? 'max-h-40 pb-5' : 'max-h-0'}`}
              >
                <p className="text-muted-foreground leading-relaxed">{faq?.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}